import Api from 'api/index'

const config = {
  baseURL: '/api/app/v2',
}
const api = new Api(config)

api.accountAccessCreate = ({ networkType, ...rest }) =>
  api.post(`/${networkType}/agency-manager-client-manager`, {
    ...rest,
  })

export default api
